import environment from '@/environments/environment';
import { getCustomAxiosClient } from '@/apis/custom-axios-client';

const { IAM_ACCOUNTS_API_URL } = environment;
export default getCustomAxiosClient({ baseURL: IAM_ACCOUNTS_API_URL });
